import axios from 'axios';

const getBaseUrl = () => {
    // If VITE_BASE_URL is provided (production), use it.
    // Otherwise, use a relative path which will be handled by the Vite proxy in dev.
    return (import.meta.env.VITE_BASE_URL || '') + '/api';
};

const API = axios.create({
    baseURL: getBaseUrl(),
});

// Add token to requests
API.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Handle global authentication failures
API.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const { status, data } = error.response;

            // Institutional Deactivation Guard
            if (status === 403 && data.message?.includes('suspended')) {
                localStorage.removeItem('token');
                window.location.href = '/account-disabled';
            }

            // Session Expiry Guard
            if (status === 401) {
                localStorage.removeItem('token');
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
            }
        }
        return Promise.reject(error);
    }
);

export default API;
